module.exports = __webpack_public_path__ + "img/defp.70f6b32c.png";